<template>
    <div class="vrm-modal vrm-modal--alert mfp-with-anim">
        <div class="vrm-modal__content">
            <div class="vrm-modal__title him--info-icon">
                <span class="sg-vrm-icon_061_info-round-16px" />
            </div>
            <div v-html="$t('dashboard.ess_info_content')" />
            <div class="vrm-modal__main-button">
                <button class="sg-element sg-btn sg-site" @click="onClose">
                    {{ $t('common.close', { i18nFallback: 'Close' }) }}
                </button>
            </div>
        </div>
        <modal-close-handle />
    </div>
</template>
<style scoped>
.him--info-icon > span {
    font-size: 4rem;
    color: #249df0;
}
</style>
<script>
import { Vue, Component } from 'vue-property-decorator';
import ModalCloseHandle from '@/vue/components/modals/ModalCloseHandle';
import { AngularLocaleBundle } from '../../../angular-bridge/modules/i18n';

@Component({
    components: { ModalCloseHandle },
})
@AngularLocaleBundle('dashboard')
@AngularLocaleBundle('common')
export default class HistoryInfoModal extends Vue {
    onClose() {
        this.$emit('close');
    }
}
</script>
